<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.7617 14.2888C22.9258 12.3548 22.4469 12.0309 22.7085 11.0639L23.8745 10.3022C25.8696 17.8649 20.5272 25.5325 12.8883 25.9795C6.06063 26.3718 0.412312 21.0669 0.0221612 14.2341C-0.199515 10.3797 1.25025 6.82644 3.9946 4.23104C6.9961 1.38932 11.2301 0.312845 15.2203 1.38932C15.0518 1.71318 14.8878 1.96405 14.7237 2.24229L14.3868 2.81702C8.17542 1.4623 2.12365 5.9461 1.56946 12.4825C1.30788 15.5797 2.24336 18.5628 4.28278 20.8389C8.26852 25.2953 14.8878 25.6283 19.277 21.6052C21.3208 19.7305 22.5223 17.1259 22.7662 14.2888H22.7617Z"
      :fill="fill"/>
    <path
      d="M17.721 15.972C18.3106 14.5078 18.3062 13.4085 18.0579 11.8622L18.7318 11.178C18.8426 11.0685 19.2594 11.1415 19.3924 11.2328C20.2569 13.7187 19.5032 16.7565 17.8274 18.7134C15.3357 21.628 11.1194 22.1526 7.9938 20.0544C4.86372 17.9516 3.6578 13.7506 5.24944 10.2247C6.81891 6.74895 10.614 4.88336 14.2894 6.00089C14.3648 6.11949 14.4933 6.51632 14.4224 6.66229C14.285 6.94509 13.948 7.25982 13.6731 7.47421C10.0111 6.48896 6.33566 9.19839 6.08294 13.071C5.95437 15.0871 6.6859 16.8706 8.14454 18.1797C9.64307 19.5253 11.6071 20.0453 13.6598 19.5344C15.349 19.1148 16.9761 17.8239 17.721 15.9811V15.972Z"
      :fill="fill"/>
    <path
      d="M21.1523 9.09346L17.9823 8.60084L12.8039 13.9376C12.5291 14.2204 12.1079 14.3755 11.7975 14.1885C11.5448 14.0334 11.1281 13.4952 11.4428 13.1667L16.9537 7.46962L16.4394 4.37247C16.3641 3.90722 16.6079 3.4374 16.9404 3.0953L19.8887 0.0893744C20.137 -0.161499 20.7843 0.166917 20.8907 0.445159L22.0301 3.32337L24.5927 4.35879C24.8498 4.4637 25.0626 4.65528 25.1691 4.88791C25.2489 5.07036 25.2178 5.54474 25.0582 5.70895L22.3227 8.52786C22.0611 8.79698 21.5868 9.15732 21.1567 9.09346H21.1523ZM19.4853 4.81949L20.4961 3.70652C20.3321 3.20021 20.1592 2.74864 19.902 2.27882L17.9158 4.30861L18.2971 6.06017C18.7183 5.67246 19.0818 5.2665 19.4897 4.81949H19.4853ZM22.7483 5.86859C22.8281 5.78193 22.9124 5.62228 23.0011 5.4672L21.5912 4.89247L19.3966 7.17314L21.1877 7.50155L22.7483 5.86859Z"
      :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: "TargetIcon",
  props: {
    fill: {
      type: String,
      default: 'currentColor'
    },
    size: {
      type: [String, Number],
      default: 26
    }
  }
}
</script>
